import axios from 'axios';
import env from '../../config';
import type { ReservationsAdd } from '@opanuj/shared/types/api';
import { useMutation } from '@tanstack/react-query';

export type useReservationsAddProps = {
	onSuccess: () => void
}

const useReservationsAdd = ({onSuccess}: useReservationsAddProps) => {
	return useMutation({
		mutationFn: (data: ReservationsAdd['body']) => {
			return axios.post(env.endpoints.reservationsAdd, data, {
				headers: {
					'Content-Type': 'application/json',
				},
			});
		},
		onSuccess
	})
}

export default useReservationsAdd;